import { storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc';
import { resolveLink } from '@/lib/helpers';

/**
 * Link — wraps any blocks in a single clickable <a>. Renders its children as
 * server components, so it can hold server-rendered blocks (Box, Card, Grid…).
 * Use this instead of per-component link fields. Don't nest other links/buttons
 * inside — a nested <a> is invalid HTML.
 */
const Link = ({ blok }) => {
  const href = resolveLink(blok.link);
  const children = blok.body?.map((b) => <StoryblokServerComponent blok={b} key={b._uid} />);

  if (!href || href === '#') {
    return <div {...storyblokEditable(blok)}>{children}</div>;
  }

  // Storyblok's multilink carries its own "open in new tab" flag; honour it, and
  // pair it with the rel that stops the new tab reaching back into this one.
  const newTab = blok.link?.target === '_blank';

  return (
    <a
      {...storyblokEditable(blok)}
      href={href}
      className="block h-full"
      target={newTab ? '_blank' : undefined}
      rel={newTab ? 'noopener noreferrer' : undefined}
    >
      {children}
    </a>
  );
};

export default Link;
